export default "__VITE_ASSET__CxVBvOAQ__"